import {
    DatadogProviderConfiguration,
    DdLogs,
    DdSdkReactNative,
    SdkVerbosity,
    UploadFrequency,
} from './datadog';
import { Platform } from '../web/react-native';
import Config from '../services/config';
import DeviceInfo from '../services/deviceInfo';
import uuid from '../services/uuid';

export const correlationId = uuid.v4();
export const deviceId = DeviceInfo.getUniqueIdSync() // WARN: sensitive data for Google https://github.com/react-native-device-info/react-native-device-info#getuniqueid

export function getDatadogConfig() {
    const config = new DatadogProviderConfiguration(
        'puba1efd98505f2bb571f01dcca58c0cd48', // dd_rum_token
        'mobility',
        "bb7e17d2-6482-49df-abb5-2dd34165569b", // dd_rum_appId
        true, // track User interactions (e.g.: Tap on buttons. You can use 'accessibilityLabel' element property to give tap action the name, otherwise element type will be reported)
        true, // track XHR Resources
        true // track Errors
    );
    
    config.serviceName = "ops-logbook-pwa";    
    config.nativeCrashReportEnabled = true;
    config.verbosity = SdkVerbosity.INFO;
    config.site = "US1";
    config.longTaskThresholdMs = 100;
    config.sessionSamplingRate = 100;
    config.uploadFrequency = UploadFrequency.FREQUENT;
    config.env = Config.ENVIRONMENT_NAME || 'development';

    return config;
}

export function onDatadogInitialization() {
    DdSdkReactNative.setAttributes({
        'device-model': DeviceInfo.getModel(),
        'device-id': deviceId,
        'device-os-version': DeviceInfo.getSystemVersion(),
        'build': DeviceInfo.getVersion(),
        'correlationId': correlationId,
        'xom_debug': true,
        'xom_app_service_level' : 2,
        'xom_env': Config.ENVIRONMENT_NAME || 'development',
        'xom_org': 'EE',
        'xom_hosting_env': Platform.OS,
        'xom_hosting_type': 'mobile',
        'xom_app_support_group': 'developer-services-mobile-delivery',
        'xom_app_support_group_dl': 'MobileDevDelivery_exxonmobil.com',
        'xom_app_id': 'APP-4186', // is this right?
        'xom_app_name': DeviceInfo.getApplicationName()
    })
    DdLogs.info('RN datadog sdk initialized')
}